import React, { useEffect } from 'react';

export default function useTimedHighlight(date: number, highlightDuration: number = 2000) {
  const [isHighlighted, setIsHighlighted] = React.useState(Date.now() - date < highlightDuration);
  useEffect(
    () => {
      const elapsed = Date.now() - date;
      if (elapsed < highlightDuration) {
        setIsHighlighted(true);
        const schedule = setTimeout(() => { setIsHighlighted(false); }, highlightDuration - elapsed);
        return () => {
          clearTimeout(schedule);
        };
      }
      return undefined;
    },
    [date],
  );
  return isHighlighted;
}
